import { StrDeduplication } from "@/components/non_registrant/str-deduplication";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/operator/str_/deduplication")({
  validateSearch: (search: Record<string, unknown>) => ({
    listingId:
      typeof search.listingId === "string" ? search.listingId : undefined,
    returnTo: typeof search.returnTo === "string" ? search.returnTo : undefined,
  }),
  component: DeduplicationRoute,
});

function DeduplicationRoute() {
  const search = Route.useSearch();
  return <StrDeduplication {...search} />;
}
